import resourceExists from "../middleware/library/resourceExists";
import userMustChangePasswordCheck from "../middleware/userMustChangePasswordCheck";

export default [
    {
        path: "/course",
        name: "course.home",
        component: () => {
            return import(
                 "@/projects/course/App.vue"
            );
        },
        meta: {
            breadcrumb: null
        },
        children: [
            {
                path: "resource/:resourceId",
                props: true,
                name: "course.resource.inline",
                components: {
                    subview: () => {
                        return import(
                             "@/projects/course/views/StackedResources.vue"
                        );
                    }
                },
                meta: {
                    title: "library.showresource.title",
                    middleware: [resourceExists, userMustChangePasswordCheck]
                }
            }
        ]
    }
];
